// Copyright (c) 2016 Deere & Company

import OpenMaintenancePlans, {getDefaultState as getOpenMaintenancePlansDefaultState} from '../state/open-maintenance-plans';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const resetOpenMaintenancePlans = () => getOpenMaintenancePlansDefaultState();

const updateOpenMaintenancePlans = (state, action) =>
    OpenMaintenancePlans.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().openMaintenancePlans, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetOpenMaintenancePlans,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_OPEN_MAINTENANCE_PLANS]: updateOpenMaintenancePlans
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/open-maintenance-plans.js